// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.typecont {\n  background-color: white;\n  padding: 50px;\n  margin: 0 15%;\n  border-radius: 6px;\n}\n", ""]);
// Exports
module.exports = exports;
